<button tabindex="-1" class="sv-popup__close-button sd-action sd-action--icon" (click)="popupModel.clickClose()">
  <svg class="sv-popup__close-button-icon" [iconName]="'icon-close-24x24'" [size]="'auto'" sv-ng-svg-icon></svg>
</button>